










































































import Vue from 'vue';

export default Vue.extend({
  name: 'NewsItem',
  props: {
    newsitem: Object,
    paid: Boolean,
  },
  data() {
    return {
      item: this.newsitem,
    };
  },
});
